export default __webpack_public_path__ + "static/media/qr-img.674a5d9d.svg";